"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2892],{

/***/ 56130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CalculatorBlogs_Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/CalculatorBlogs/BlogCard.jsx




const BlogCard = (param)=>{
    let { question , answer  } = param;
    const [blogVisible, setBlogVisible] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex mb-[30px] pb-[30px] gap-[20px] border-b border-b-gray-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>blogVisible ? setBlogVisible(false) : setBlogVisible(true),
                className: "pt-[5px] text-[20px] md:text-[35px] w-fit cursor-pointer",
                children: blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMinus */.ywL, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "question text-[25px] md:text-[30px] mb-[20px] font-medium",
                        children: question
                    }),
                    blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "answer text-[16px] md:text-[18px] font-light text-gray-700",
                        children: answer
                    }) : ""
                ]
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/CalculatorBlogs/Blog.jsx



const Blog = (param)=>{
    let { heading , BlogData , width ="lg:w-[850px]"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] mx-auto md:w-[80%] ".concat(width),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[25px] md:text-[40px] text-center font-bold mb-14 mx-auto",
                children: heading
            }),
            BlogData.map((blog)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorBlogs_BlogCard, {
                    question: blog.question,
                    answer: blog.answer
                }, blog.id);
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_Blog = (Blog);


/***/ }),

/***/ 69926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const SalesTaxCalc = (param)=>{
    let { salesTaxState , state_tax , avg_local_tax , max_local_tax , combined_tax  } = param;
    const [price, setPrice] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [priceType, setPriceType] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("beforeTax");
    const [numGoods, setNumGoods] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("1");
    const [stateTaxRate, setStateTaxRate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("".concat(state_tax));
    const [avgLocalTaxRate, setAvgLocalTaxRate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("".concat(avg_local_tax));
    const [maxLocalTaxRate, setMaxLocalTaxRate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("".concat(max_local_tax));
    const [combinedTaxRate, setCombinedTaxRate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("".concat(combined_tax));
    const [totalPrice, setTotalPrice] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        state_price: "",
        avg_local_price: "",
        max_local_price: "",
        combined_price: ""
    });
    function handleCalculateTotalPrice() {
        const inputPrice = parseFloat(price);
        const state_tax_rate = parseFloat(stateTaxRate);
        const avg_local_tax_rate = parseFloat(avgLocalTaxRate);
        const max_local_tax_rate = parseFloat(maxLocalTaxRate);
        const combined_tax_rate = parseFloat(combinedTaxRate);
        const inputNumGoods = parseInt(numGoods);
        if (isNaN(inputPrice) || isNaN(state_tax_rate) || isNaN(inputNumGoods)) {
            setTotalPrice((prev)=>({
                    ...prev,
                    state_price: "Enter Price"
                }));
            return;
        }
        let total_price = 0;
        let totalStatePrice = 0;
        let totalLocalPrice = 0;
        let totalMaxPrice = 0;
        let totalCombinedPrice = 0;
        if (priceType === "beforeTax") {
            totalStatePrice = inputPrice * (1 + state_tax_rate / 100) * inputNumGoods;
            totalLocalPrice = inputPrice * (1 + avg_local_tax_rate / 100) * inputNumGoods;
            totalMaxPrice = inputPrice * (1 + max_local_tax_rate / 100) * inputNumGoods;
            totalCombinedPrice = inputPrice * (1 + combined_tax_rate / 100) * inputNumGoods;
        } else {
            total_price = inputPrice * inputNumGoods;
            totalStatePrice = total_price / (1 + state_tax_rate / 100);
            totalLocalPrice = total_price / (1 + avg_local_tax_rate / 100);
            totalMaxPrice = total_price / (1 + max_local_tax_rate / 100);
            totalCombinedPrice = total_price / (1 + combined_tax_rate / 100);
        }
        setTotalPrice((prev)=>({
                ...prev,
                state_price: totalStatePrice.toFixed(2),
                avg_local_price: totalLocalPrice.toFixed(2),
                max_local_price: totalMaxPrice.toFixed(2),
                combined_price: totalCombinedPrice.toFixed(2)
            }));
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setStateTaxRate(state_tax);
        setAvgLocalTaxRate(avg_local_tax);
        setMaxLocalTaxRate(max_local_tax);
        setCombinedTaxRate(combined_tax);
    // console.log("Hello")
    }, [
        state_tax,
        avg_local_tax,
        max_local_tax,
        combined_tax
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-white w-full xl:w-[1000px] py-10 px-[10px] md:px-[30px] rounded-lg drop-shadow-2xl mx-auto h-fit",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col gap-[20px] items-start xl:flex-row",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-[100%] mx-auto xl:w-[50%] bg-white py-[30px] md:py-[30px] grid place-items-center h-full xl:h-[600px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                            className: "text-gray-500 font-medium text-[20px] border-b-2 pb-[5px] mb-[20px] text-left",
                            children: [
                                "Calculate Sales Tax ",
                                salesTaxState ? "for " + salesTaxState : ""
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col gap-[15px] justify-center items-start w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex w-[100%] justify-between items-center gap-[10px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                            htmlFor: "",
                                            className: "text-gray-500 font-medium text-[20px]",
                                            children: "Price"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col xl:flex-row gap-[5px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    type: "text",
                                                    className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]",
                                                    value: price,
                                                    onChange: (e)=>setPrice(e.target.value)
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                                    className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]",
                                                    id: "",
                                                    name: "",
                                                    required: true,
                                                    value: priceType,
                                                    onChange: (e)=>setPriceType(e.target.value),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                            value: "beforeTax",
                                                            children: "Before Tax"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                            value: "afterTax",
                                                            children: "After Tax"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex w-[100%] justify-between items-center gap-[10px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                            htmlFor: "",
                                            className: "text-gray-500 font-medium text-[20px]",
                                            children: "No. Of Goods"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                            type: "text",
                                            className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]",
                                            value: numGoods,
                                            onChange: (e)=>{
                                                setNumGoods(e.target.value);
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full h-[1px] bg-gray-200 my-[20px]"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col gap-[10px] justify-between items-center w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex w-[100%] justify-between items-center gap-[10px] mx-auto",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                            htmlFor: "",
                                            className: "text-gray-500 font-medium text-[20px] text-left",
                                            children: "State Tax Rate"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                            type: "text",
                                            className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]",
                                            value: stateTaxRate,
                                            onChange: (e)=>{
                                                setStateTaxRate(e.target.value);
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex w-[100%] justify-between items-center gap-[10px] mx-auto",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                            htmlFor: "",
                                            className: "text-gray-500 font-medium text-[20px] text-left",
                                            children: "Avg. Local Tax Rate"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                            type: "text",
                                            className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]",
                                            value: avgLocalTaxRate,
                                            onChange: (e)=>{
                                                setAvgLocalTaxRate(e.target.value);
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex w-[100%] justify-between items-center gap-[10px] mx-auto",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                            htmlFor: "",
                                            className: "text-gray-500 font-medium text-[20px] text-left",
                                            children: "Combined Rate"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                            type: "text",
                                            className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]",
                                            value: combinedTaxRate,
                                            onChange: (e)=>{
                                                setCombinedTaxRate(e.target.value);
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: handleCalculateTotalPrice,
                            className: "w-full mt-[30px] h-[50px] bg-violet-500 hover:opacity-75 text-white font-medium text-[18px] rounded-lg shadow-2xl",
                            children: "Calculate"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-[100%] xl:w-[50%] h-full xl:h-[600px] flex flex-col items-center justify-center gap-[20px] pb-[20px] xl:pb-[0px] rounded-lg bg-slate-200",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                            className: "text-white py-[2px] mb-[10px] h-[50px] flex items-center text-center justify-center px-[10px] font-medium text-[25px] bg-violet-500",
                            children: [
                                "Price ",
                                priceType === "beforeTax" ? "After Tax" : "Before Tax"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full text-gray-500 font-medium flex flex-col gap-[10px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: " flex items-center gap-[30px] justify-around text-[20px] mx-[15px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-[50%] text-center border-b-[1px] border-b-gray-400 pb-[5px] px-[5px]",
                                            children: "Tax Category"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-[50%] text-center border-b-[1px] border-b-gray-400 pb-[5px] px-[5px]",
                                            children: "Total Cost"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: " flex items-center justify-around text-[18px] text-gray-400",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-[50%] text-center",
                                            children: "State Tax"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-[50%] text-center",
                                            children: [
                                                "$",
                                                totalPrice.state_price
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: " flex items-center justify-around text-[18px] text-gray-400",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-[50%] text-center",
                                            children: "Avg. Local Tax"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-[50%] text-center",
                                            children: [
                                                "$",
                                                totalPrice.avg_local_price
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: " flex items-center justify-around text-[18px] text-gray-400",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-[50%] text-center",
                                            children: "Combined Tax"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-[50%] text-center",
                                            children: [
                                                "$",
                                                totalPrice.combined_price
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SalesTaxCalc);


/***/ }),

/***/ 54820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BlogData": function() { return /* binding */ BlogData; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Tools_SalesTaxCalculator_SalesTaxCalc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69926);
/* harmony import */ var _SalesTaxData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15425);
/* harmony import */ var _components_CalculatorBlogs_Blog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56130);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_5__);






const BlogData = [
    {
        id: 1,
        question: "What is a sales tax calculator?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "A sales tax calculator is a tool that calculates the amount of sales tax that will be added to a purchase based on the purchase price and the applicable tax rate. Sales tax calculators are commonly used by consumers to estimate the total cost of a purchase, including tax."
            })
        })
    },
    {
        id: 2,
        question: "How do I use a sales tax calculator?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "To use a sales tax calculator, simply enter the purchase price and the applicable tax rate into the calculator, and the calculator will automatically calculate the amount of sales tax that will be added to the purchase price. Some sales tax calculators may also provide a breakdown of the total cost, including tax."
            })
        })
    },
    {
        id: 3,
        question: "What is the difference between a state sales tax and a local sales tax?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "State sales taxes are taxes that are imposed by the state government on retail sales of goods and services within the state. Local sales taxes, on the other hand, are taxes that are imposed by local governments (such as cities, counties, or municipalities) on top of the state sales tax. The total sales tax rate for a purchase will depend on the combined state and local tax rates that apply."
            })
        })
    },
    {
        id: 4,
        question: "How are sales tax rates determined?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "Sales tax rates are determined by state and local governments. In the United States, each state has its own sales tax rate, which is typically a percentage of the purchase price. Local governments may also impose additional sales taxes on top of the state sales tax. The total sales tax rate for a purchase will depend on the combined state and local tax rates that apply."
            })
        })
    },
    {
        id: 5,
        question: "Are sales taxes included in the advertised price of goods or services?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "No, sales taxes are not typically included in the advertised price of goods or services. Instead, the sales tax is added to the purchase price at the time of sale. However, some businesses may choose to advertise prices that include the sales tax as a way of simplifying the purchasing process for consumers."
            })
        })
    },
    {
        id: 6,
        question: "Are there any exemptions or special rules that apply to sales tax?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "Yes, there may be exemptions or special rules that apply to sales tax, depending on the jurisdiction and the type of purchase. For example, some states may exempt certain types of goods or services from sales tax (such as groceries or prescription drugs), while others may impose additional taxes on specific items (such as luxury goods or cigarettes). Additionally, some states may offer sales tax holidays, during which certain purchases are exempt from sales tax for a limited period of time."
            })
        })
    },
    {
        id: 7,
        question: "Is sales tax the same as value-added tax (VAT)?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "No, sales tax and value-added tax (VAT) are two different types of taxes. Sales tax is a tax that is imposed on the sale of goods and services at the retail level, while VAT is a tax that is imposed on the value added at each stage of production and distribution of goods and services. VAT is commonly used in many countries outside of the United States."
            })
        })
    },
    {
        id: 8,
        question: "Can sales tax be refunded or deducted?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "In some cases, sales tax may be refunded or deducted. For example, if a business purchases goods for resale, it may be able to deduct the sales tax paid on those purchases from its own sales tax liability. Additionally, some states may offer sales tax refunds for purchases made by certain groups (such as non-residents or military personnel). However, the rules for sales tax refunds and deductions can vary widely by jurisdiction, so it's important to check with the relevant tax authorities for specific guidance."
            })
        })
    }
];
const SalesTaxCalculator = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container mx-auto w-full px-[10px] lg:px-[100px] py-[80px] flex flex-col items-center gap-[20px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_5___default()), {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                charSet: "utf-8"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                children: "Sales Tax Calculator | Calculators | BoloSign"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "description",
                                content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "geo.region",
                                content: "IN"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "geo.position",
                                content: "22.351115;78.667743"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "ICBM",
                                content: "22.351115, 78.667743"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "author",
                                content: "BoloSign"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "publisher",
                                content: "BoloSign "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "robots",
                                content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "https://www.bolosign.com/calculators/sales-tax-calculator/"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "https://www.bolosign.com/calculators/sales-tax-calculator/"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:type",
                                content: "website"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:title",
                                content: "Sales Tax Calculator | Calculators | BoloSign"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:description",
                                content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:image",
                                content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:card",
                                content: "summary_large_image"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "twitter:domain",
                                content: "https://bolosign.com"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "twitter:url",
                                content: "https://www.bolosign.com/calculators/sales-tax-calculator/"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:title",
                                content: "Sales Tax Calculator | Calculators | BoloSign"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:description",
                                content: "Sales Tax Calculator | Calculators | BoloSign"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:image",
                                content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute top-0 z-[-500] left-0 w-full bg-violet-500 h-[600px]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col gap-[30px] w-full xl:w-[70%] text-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "font-bold text-[45px] xl:text-[60px] leading-[45px] xl:leading-[60px] text-white",
                                children: "Sales Tax Calculator"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-white text-[16px] xl:text-[18px] font-light",
                                children: "Are you tired of manually calculating sales tax every time you make a purchase? Look no further than our convenient and easy-to-use sales tax calculator. Whether you're a business owner or a savvy shopper, our calculator takes the guesswork out of calculating sales tax, ensuring that you always know the exact amount you'll be paying. Try it today and see how easy sales tax calculations can be!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Tools_SalesTaxCalculator_SalesTaxCalc__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        salesTaxState: "",
                        state_tax: "0",
                        avg_local_tax: "0",
                        max_local_tax: "0",
                        combined_tax: "0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SalesTaxData__WEBPACK_IMPORTED_MODULE_3__["default"], {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CalculatorBlogs_Blog__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                heading: "Sales Tax Calculator FAQs",
                BlogData: BlogData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SalesTaxCalculator);


/***/ })

}]);